"use client";

import { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { useTranslations } from "next-intl";

export default function NotFound() {
  const t = useTranslations("errors");
  useEffect(() => {
    const splash = document.getElementById("boot-splash");
    if (splash) splash.style.display = "none";
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-gray-50 dark:bg-neutral-950 px-4">
      <Image src="/logo.png" alt="Atlas" width={56} height={56} className="rounded-xl shadow-md" />
      <div className="text-center space-y-2">
        <h1 className="text-6xl font-bold text-gray-200 dark:text-neutral-700">404</h1>
        <p className="text-lg font-medium text-gray-700 dark:text-neutral-200">{t("notFound.title")}</p>
        <p className="text-sm text-gray-400 dark:text-neutral-400">{t("notFound.description")}</p>
      </div>
      <Link
        href="/"
        className="mt-2 inline-flex items-center gap-2 rounded-lg bg-brand-dark px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-brand-dark/90 transition-colors"
      >
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}
